import { z } from 'zod';
import { IsoDatetimeToDateSchema, NullableIsoDatetimeToDateSchema } from './date-codecs.js';
import { TimelineCliTweetBoundarySchema } from './timeline.js';
import { TimelineFetchModeSchema } from './timeline-fetch.js';

export const TimelineSnapshotCliMetadataSchema = z.object({
  id: z.string(),
  updatedAt: NullableIsoDatetimeToDateSchema,
  createdAt: NullableIsoDatetimeToDateSchema,
  tweetCount: z.number(),
  sinceId: z.string().nullable(),
  metadata: z.record(z.string(), z.unknown()).nullable(),
});

export const TimelineSnapshotCliCoverageSchema = z.object({
  dataComplete: z.boolean(),
  needsSync: z.boolean(),
  coveragePercent: z.number(),
  tweetCount: z.number().nullable(),
  maxTweets: z.number().nullable(),
  oldestDataPoint: NullableIsoDatetimeToDateSchema,
  newestDataPoint: NullableIsoDatetimeToDateSchema,
  capReached: z.boolean().nullable(),
});

export const TimelineSnapshotCliResponseSchema = z.object({
  timelineType: z.enum(['home', 'mentions']),
  mode: TimelineFetchModeSchema,
  limit: z.number(),
  returnedCount: z.number(),
  triggeredSync: z.boolean(),
  requestedAt: IsoDatetimeToDateSchema,
  snapshot: TimelineSnapshotCliMetadataSchema.nullable(),
  coverage: TimelineSnapshotCliCoverageSchema.nullable(),
  tweets: z.array(TimelineCliTweetBoundarySchema),
});

export type TimelineSnapshotCliResponse = z.infer<typeof TimelineSnapshotCliResponseSchema>;
export type TimelineSnapshotCliResponseInput = z.input<typeof TimelineSnapshotCliResponseSchema>;

export const TimelineSnapshotCliResponseBoundarySchema = TimelineSnapshotCliResponseSchema;

export function parseTimelineSnapshotCliResponse(input: TimelineSnapshotCliResponseInput): TimelineSnapshotCliResponse {
  return TimelineSnapshotCliResponseBoundarySchema.parse(input);
}
